import QrModal from './QrModal';

import './QrModal.scss';

export default QrModal;
